<template>
  <div class="work-section">
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item title="Настройки 'Общие работы'" name="2">
        <div>
          <div class="work-section-menu">
            <div class="section-li">
              <span>Отчет "Общие работы"</span>
              <el-checkbox v-model="available_reports.MAIN" @change="save"></el-checkbox>
            </div>
            <div class="section-li">
              <span>Отчет "Общие работы c материалами"</span>
              <el-checkbox v-model="available_reports.MATERIALS" @change="save"></el-checkbox>
            </div>
          </div>
          <div class="edit-ul">
            <router-link
              :to="`/dashboard/materials`"
              class="edit-li"
            >
              Материалы <i class="fas fa-chevron-right"></i>
            </router-link>
            <router-link
              :to="`/dashboard/works/list/executor`"
              class="edit-li"
            >
              Исполнители <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="Настройки 'Монтаж трубопроводов'" name="1">
        <div>
          <div class="work-section-menu">
            <div class="section-li">
              <span>Отчет по сварке трубопроводов</span>
              <el-checkbox v-model="available_reports.WILD_PIPE" @change="save"></el-checkbox>
            </div>
            <div class="section-li">
              <span>Отчет по лабораторному контролю (В разработке)</span>
              <el-checkbox disabled></el-checkbox>
            </div>
            <div class="section-li">
              <span>Отчет по термообработке (В разработке)</span>
              <el-checkbox disabled></el-checkbox>
            </div>
          </div>

          <div class="edit-ul">
            <router-link
              :to="`/dashboard/works/list/line`"
              class="edit-li"
            >
              Линии <i class="fas fa-chevron-right"></i>
            </router-link>
            <router-link
              :to="`/dashboard/works/list/welder`"
              class="edit-li"
            >
              Сварщики <i class="fas fa-chevron-right"></i>
            </router-link>
            <router-link
              :to="`/dashboard/works/list/welder_cons`"
              class="edit-li"
            >
              Сварочные материалы <i class="fas fa-chevron-right"></i>
            </router-link>

            <router-link
              :to="`/dashboard/works/list/team`"
              class="edit-li"
            >
              Бригады <i class="fas fa-chevron-right"></i>
            </router-link>

            <router-link
              :to="`/dashboard/inch`"
              class="edit-li"
            >
              Дюймы <i class="fas fa-chevron-right"></i>
            </router-link>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="Настройки 'Монтаж конструкций' (В разработке)">
      </el-collapse-item>

      <el-collapse-item title="Настройки 'Электромонтажные работы' (В разработке)">
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import firebase from 'firebase';

export default {
  name: 'WorkSection',
  data() {
    return {
      activeNames: [],
      available_reports: {
        WILD_PIPE: false,
        MATERIALS: false,
        MAIN: false,
      },
    };
  },
  methods: {
    handleChange(val) {
    },
    save() {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .update({
          ...this.$store.state.project,
          plan: null,
          available_reports: this.available_reports,
        }).then(() => {
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Сохранено',
          type: 'success',
        });
        this.$store.dispatch('setProject', {
          ...this.$store.state.project,
          available_reports: {
            ...this.$store.state.project.available_reports,
            ...this.available_reports,
          },
          id: this.$store.state.project.id,
        });
      })
        .catch((error) => console.error(error));
    },
  },

  mounted() {
    const {available_reports} = this.$store.state.project;
    if (this.available_reports) {
      this.available_reports = {
        ...this.available_reports,
        ...available_reports,
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.work-section {
  max-width: 492px;
  margin: 42px auto;
  font-size: 16px !important;
  width: calc(100% - 30px);


  > > > .el-collapse-item__header {
    height: auto;
    line-height: 20px;
    font-size: 14px !important;
    text-align: left;
    padding: 10px 0;
  }

  > > > .el-collapse-item__wrap {
    .el-collapse-item__content {
      font-size: 14px !important;
    }
  }
}

.work-section-menu {
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  .section-li {
    display: flex;
    justify-content: space-between;
    margin-left: 20px;
    margin-bottom: 10px;

    span {
      text-align: left;
    }
  }
}

.edit-ul {
  width: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 20px;


  .edit-li {
    display: flex;
    justify-content: space-between;
    height: 40px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    align-items: center;
    padding: 0 10px;
    text-decoration: none;
    color: #000;

    span:first-child {
      margin-right: 20px;
    }

    span {
      margin-right: 5px;
    }

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #f5f5f5;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Projects/WorkSection.vue